/**
 * PausedMembershipBanner — banner-center source (§7.10 pause freeze, owner
 * decision 5, 2026-08-16).
 *
 * When the signed-in member's OWN membership in the ACTIVE workspace is
 * suspended, this says so plainly: their access is FROZEN, not ended — org
 * threads stay visible read-only (nothing disappears), and posting/switching
 * are blocked server-side until an admin resumes them. Rides the one global
 * banner band like every other status notice; not dismissible (a frozen
 * member must always know why the workspace is read-only).
 *
 * Membership status arrives via useRbac (member-doc read / callable field) —
 * null/unknown renders nothing, so this can never false-fire while loading.
 */

import React from 'react';
import { useRbac } from '../../hooks/useRbac';
import { useBannerSurface } from './bannerSurface';
import { useRegisterBanner, BannerDescriptor } from './GlobalBannerCenter';

export const PausedMembershipBanner: React.FC = () => {
  const onAppSurface = useBannerSurface();
  const { membershipStatus, loading, isOwner } = useRbac();

  const paused = !loading && !isOwner && membershipStatus === 'suspended';

  const banner: BannerDescriptor | null =
    onAppSurface && paused
      ? {
        id: 'paused-membership',
        tone: 'warn',
        dismissible: false,
        content: (
          <span data-paused-membership-banner="">
            your membership in this organization is paused — threads stay visible but are
            read-only until an admin resumes your access. your own organization is unaffected:
            switch workspaces in the top-right menu.
          </span>
        ),
      }
      : null;

  useRegisterBanner(banner);
  return null;
};

export default PausedMembershipBanner;
